var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticClass:"HeatMap"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],staticClass:"HeatMapMask"})])
}
var staticRenderFns = []

export { render, staticRenderFns }